import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  IPricePoint,
  IPrestationPriceBulkImport,
  IPrestationPriceImpact,
  IPrestationPriceRangeUpdate,
  PackageV1Prestation,
} from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';
import ApiService from '../api.service.abstract';

@Injectable({ providedIn: 'root' })
export class PackageV1PrestationService extends ApiService<PackageV1Prestation> {
  constructor(
    @Inject(APP_CONFIG) environment: any,
    protected http: HttpClient
  ) {
    super(environment, http, 'package/api/package-v1-prestations');
    if (environment.name == 'localDev') {
      this.url = 'http://localhost:8101';
    }
  }

  public addPrice(
    id: string,
    point: IPricePoint
  ): Observable<HttpResponse<PackageV1Prestation>> {
    return this.http.post<PackageV1Prestation>(
      `${this.url}/${this.endpoint}/${id}/prices`,
      point,
      { observe: 'response' }
    );
  }

  public updatePrice(
    id: string,
    date: string,
    price: number
  ): Observable<HttpResponse<PackageV1Prestation>> {
    return this.http.put<PackageV1Prestation>(
      `${this.url}/${this.endpoint}/${id}/prices/${date}`,
      price,
      { observe: 'response' }
    );
  }

  public removePrice(
    id: string,
    date: string
  ): Observable<HttpResponse<PackageV1Prestation>> {
    return this.http.delete<PackageV1Prestation>(
      `${this.url}/${this.endpoint}/${id}/prices/${date}`,
      { observe: 'response' }
    );
  }

  public getPricesByDateRange(
    id: string,
    startDate: string,
    endDate: string
  ): Observable<HttpResponse<IPricePoint[]>> {
    return this.http.get<IPricePoint[]>(
      `${this.url}/${this.endpoint}/${id}/prices/date-range`,
      { params: { startDate, endDate }, observe: 'response' }
    );
  }

  public updatePricesFromRange(
    id: string,
    dto: IPrestationPriceRangeUpdate
  ): Observable<HttpResponse<PackageV1Prestation>> {
    return this.http.post<PackageV1Prestation>(
      `${this.url}/${this.endpoint}/${id}/prices/range`,
      dto,
      { observe: 'response' }
    );
  }

  public importPrices(
    id: string,
    dto: IPrestationPriceBulkImport
  ): Observable<HttpResponse<PackageV1Prestation>> {
    return this.http.post<PackageV1Prestation>(
      `${this.url}/${this.endpoint}/${id}/prices/import`,
      dto,
      { observe: 'response' }
    );
  }

  public getPriceImpact(
    id: string,
    dto: IPrestationPriceBulkImport | IPrestationPriceRangeUpdate
  ): Observable<HttpResponse<IPrestationPriceImpact>> {
    return this.http.post<IPrestationPriceImpact>(
      `${this.url}/${this.endpoint}/${id}/prices/impact`,
      dto,
      { observe: 'response' }
    );
  }

  public exportPrices(id: string): Observable<HttpResponse<IPricePoint[]>> {
    return this.http.get<IPricePoint[]>(
      `${this.url}/${this.endpoint}/${id}/prices/export`,
      { observe: 'response' }
    );
  }
}
